export const logTypes = {
    add: 'LOG/ADD_LOG',
}
